import { isExpressCheckoutEligible } from './isExpressCheckoutEligible';
import { push } from '../../router/router-actions';
export const routeToCheckout = ({ spot, optimizely }) => {
    return (dispatch, getState) => {
        const state = getState();
        const { searchRequest, checkout: { isRebookingReservation }, user: { data: user }, eventPackage: { data: eventPackage }, } = state;
        const shouldSend = isExpressCheckoutEligible({
            spot,
            searchRequest,
            isRebookingReservation,
            eventPackage,
            isAdmin: user.isAdmin,
            optimizely,
        });
        if (shouldSend && spot.selectedRate.expressCheckoutUrl) {
            window.location.href = spot.selectedRate.expressCheckoutUrl;
        }
        else {
            dispatch(push(spot.selectedRate.fullUrl));
        }
    };
};
